import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

const BubblePlot = ({
    data,
    bubblePlotRef,
    valuetype,
}) => {

    const maxCount = Math.max(...data.map((d) => d.count));
    const sizeref = maxCount / 30;
    const [plotData, setPlotData] = useState([])
    const [bubbleColor, setBubbleColor] = useState()

    useEffect(()=>{
        valuetype == '-log(qValue)'? setBubbleColor("blue") : setBubbleColor("red")
        const plotData_qvalue= [
            {
                x: data.map((d) => -Math.log10(d.qValue)),
                y: data.map((d, i) => i), // 카테고리형 자료를 숫자형으로 변환
                mode: "markers",
                marker: {
                    size: data.map((d) => d.count),
                    sizeref: maxCount / 30, // count에 비례하는 사이즈 설정
                    sizemode: "diameter",
                    color: 'blue', // 여기서 버블 색상을 변경합니다
                },
                text: data.map((d) => `count ratio: ${d.count}, qvalue: ${d.qValue}`),
            },
        ];

        const plotData_pvalue = [
            {
                x: data.map((d) => -Math.log10(d.pValue)),
                y: data.map((d, i) => i), // 카테고리형 자료를 숫자형으로 변환
                mode: "markers",
                marker: {
                    size: data.map((d) => d.count),
                    sizeref: maxCount / 30, // count에 비례하는 사이즈 설정
                    sizemode: "diameter",
                    color: 'red', // 여기서 버블 색상을 변경합니다
                },
                text: data.map((d) => `count ratio: ${d.count}, pvalue: ${d.pValue}`),
            },
        ];        

        valuetype == '-log(qValue)'? setPlotData(plotData_qvalue) : setPlotData(plotData_pvalue)

    },[])



    // Plot layout 설정
    const layout = {
        xaxis: { title: valuetype },
        yaxis: {
            tickvals: data.map((_, i) => i),
            ticktext: data.map((d) => d.pathway),
        }, // y축 라벨 재설정
        // title: 'Pathway Bubble Chart',
        height: 620,
        width: 900,
        autosize: true, // 차트 크기를 자동으로 조정합니다
        margin: { l: 520, t: 20 }, // y축 라벨의 여백을 적절하게 조절합니다. 필요한 경우 이 값을 증가시키십시오
        paper_bgcolor: "rgba(0,0,0,0)", // 전체 배경을 투명하게 만듭니다
        plot_bgcolor: "rgba(0,0,0,0)", // 차트의 그래프 영역만 투명하게 만듭니다
    };

    const config = {
        displayModeBar: false, // 도구바를 제거합니다
        staticPlot: false, // 그래프의 상호작용을 제한합니다
    };

    // Update the size of the legend markers to match the plot markers
    const legendMarkerSizes = [20, 3, 1, 0.2].map(percent => Math.sqrt(percent / 18) * maxCount / sizeref);

    return (
        <div ref={bubblePlotRef}>
            <Plot data={plotData} layout={layout} config={config} />
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>
                {legendMarkerSizes.map((size, index) => (
                    <div style={{ display: "flex", alignItems: "center", marginRight: "20px" }} key={index}>
                        <div
                            style={{
                                width: size,
                                height: size,
                                borderRadius: "50%",
                                backgroundColor: valuetype === '-log(qValue)' ? "blue" : "red",
                                display: "inline-block",
                                opacity: 0.7
                            }}
                        />
                        <div style={{ marginLeft: "5px" }}>{[
                            (maxCount * 100).toFixed(1), 
                            (maxCount * 100 * 0.5).toFixed(1),  
                            (maxCount * 100 * 0.5 * 0.5).toFixed(1), 
                            (maxCount * 100 * 0.5 * 0.5 * 0.5).toFixed(1)
                            ][index]}%</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BubblePlot;
